import { render, staticRenderFns } from "./Vehicles.vue?vue&type=template&id=a8839a3a&scoped=true"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8839a3a",
  null
  
)

export default component.exports